/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import React from 'react';

import {EnzymeAttributes} from 'molbio/enzymes/backbone/Enzymes';

import {Provider} from './EnzymeConstants';
import * as EnzymeUtil from './EnzymeUtil';

export interface EnzymeActivityTableProps {
  small: boolean;
  provider: Provider;
  enzymes?: Array<EnzymeAttributes>;
}

class EnzymeActivityTable extends React.Component<EnzymeActivityTableProps> {
  static defaultProps = {
    small: false,
  };

  override render(): JSX.Element {
    let buffer;
    const {provider, small, enzymes} = this.props;

    const buffers = provider.buffers.filter((buffer: any) =>
      enzymes!.some(
        (enzyme) =>
          (enzyme.providedEnzymes[provider.name] != null
            ? enzyme.providedEnzymes[provider.name].activities[buffer]
            : undefined) != null
      )
    );
    const optimalBuffers = EnzymeUtil.calculateOptimalBuffers(
      enzymes!.map((enzyme) => enzyme.id),
      provider.name
    );
    return (
      <table className="table table-condensed enzymes-table">
        {/* name */}
        <colgroup>
          <col />
          {!small ? [<col key="cuts-col" />, <col key="temp-col" />] : undefined}
          {(() => {
            const result = [];
            for (buffer of Array.from(buffers)) {
              result.push(
                <col
                  key={`${buffer}-col`}
                  className={classNames({success: Array.from(optimalBuffers).includes(buffer)})}
                />
              );
            }
            return result;
          })()}
        </colgroup>
        <thead className={classNames({'u-small-text': this.props.small})}>
          <tr>
            <th>Enzymes</th>
            {!small ? [<th key="cuts-th">Cuts</th>, <th key="temp-th">Temp.</th>] : undefined}
            {(() => {
              const result1 = [];
              for (buffer of Array.from(buffers)) {
                result1.push(<th key={`${buffer}-th`}>{EnzymeUtil.formatBufferName(buffer)}</th>);
              }
              return result1;
            })()}
          </tr>
        </thead>
        <tbody>
          {enzymes!.map((enzyme) => {
            const providedEnzyme = enzyme.providedEnzymes[provider.name];
            return (
              // eslint-disable-next-line benchlint/no-in-operator
              <tr key={enzyme.id} className={classNames({faded: !(provider.name in enzyme.providedEnzymes)})}>
                <td>{enzyme.name}</td>
                {!small
                  ? [
                      <td key="cuts-td">{enzyme.cutPositions.length}</td>,
                      <td key="temp-td">
                        {(providedEnzyme != null ? providedEnzyme.incubationTemperature : undefined) != null
                          ? `${providedEnzyme.incubationTemperature}\u00b0C`
                          : '\u2014'}
                      </td>,
                    ]
                  : undefined}
                {providedEnzyme != null ? (
                  buffers.map((buffer: any) => (
                    <td key={buffer}>
                      {providedEnzyme.activities[buffer] != null
                        ? providedEnzyme.activities[buffer]
                        : '\u2014'}
                    </td>
                  ))
                ) : (
                  <td colSpan={buffers.length}>Not available for this vendor</td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default EnzymeActivityTable;
